module.exports = __webpack_public_path__ + "img/1451239865.dff2c2ff.jpg";